const sectionTextCarouselCss = `
[data-type='section-text-carousel'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-text-carousel'] [data-attribute='card-container'] .swiper-pagination {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

[data-type='section-text-carousel'] [data-attribute='card-container'] .swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: var(--pagination-inactive-color, #cccccc);
}

[data-type='section-text-carousel'] [data-attribute='card-container'] .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--pagination-active-color, #000) !important;
}

[data-type='section-text-carousel'] .wrap-card {
  padding: 0 20px;
}

[data-type='section-text-carousel'] .wrap-card .card-carousel {
  position: relative;
}

[data-type='section-text-carousel'] .wrap-card .card-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px !important;
}

[data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel {
  overflow-x: hidden;
  position: relative;
  padding: 100px 0px 100px;
}

/* .swiper-slide {
    transition: all 0.3s ease;
    height: auto;
 */
[data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel .swiper-slide.swiper-slide-active {
  z-index: 9;
}

[data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel .swiper-slide.swiper-slide-active .wrap-ct {
  transform: scale(1.1);
  box-shadow: 0 10px 25px #0000001a;
}

[data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel .wrap-ct {
  height: 100%;
  padding: 30px;
  background-color: var(--background-item-color, #fff);
  transition: all 0.3s ease;
}

[data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel .wrap-ct .decor-item {
  /* text-align: center; */
  display: flex;
  justify-content: center;
  margin-bottom: 20px !important;
}

[data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel .wrap-ct .decor-item svg {
  width: 22px;
  height: auto;
}

[data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel .wrap-ct .item-text {
  text-align: center;
  color: var(--text-item-color, inherit);
}

[data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel .wrap-ct .item-text blockquote {
  /* font-style: italic; */
  font-size: 14px;
  font-weight: bold !important;
}

[data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel .wrap-ct .item-text blockquote p {
  margin: 0;
}

@container (max-width: 1024px) {
  [data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel {
    padding: 50px 0px 50px;
  }

  [data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel .swiper-slide.swiper-slide-active .wrap-ct {
    transform: scale(1);
  }
}

@container (max-width: 768px) {
  [data-type='section-text-carousel'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-text-carousel'] .wrap-card .card-title {
    font-size: 20px;
  }

  [data-type='section-text-carousel'] .wrap-card .mySwiperTextCarousel {
    padding: 30px 0px 30px;
  }
}

@container (max-width: 480px) {
  [data-type='section-text-carousel'] .wrap-card {
    padding: 0;
  }
}
`;

export default sectionTextCarouselCss;
